import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const usePlaceLevelsState = () => React.useContext(Context) || {}
export const usePlaceLevels = () => usePlaceLevelsState()?.placeLevels || []

const QUERY = gql`
  query PlaceLevels($page: Int, $search: String, $sort: PlaceLevelSort, $filter: PlaceLevelFilter) {
    placeLevels(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      type
      levelId
      deleted
    }
  }
`

const PlaceLevelsLoader = ({ children, uncontrolledChildren, filter }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filterState = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...filterState, ...filter }
    },
    client: placesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default PlaceLevelsLoader
